import "./styles.css";
import { useState } from "react";

interface Props {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

export default function PasswordInput({ value, onChange, placeholder, disabled }: Props) {
    const [visible, setVisible] = useState(false);

    return (
        <div className="password-input-wrap">
            <input
                type={visible ? "text" : "password"}
                className="password-input-field"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
            />
            <button type="button" className="password-input-toggle" onClick={() => setVisible((v) => !v)} tabIndex={-1} disabled={disabled}>
                <img src={visible ? "/icons/eye-closed-icon.svg" : "/icons/eye-opened-icon.svg"} alt="" />
            </button>
        </div>
    );
}
